<template>
  <div class="v-nav-container">
    <nav class="v-nav" :class="{menuIsOpen: isOpen}">
      <div class="menu-nav" @click="toggleMenu()">
        <slot name="menu"></slot>
      </div>
      <div class="menu-block menu-block-logo">
        <slot name="logo"></slot>
      </div>
      <div class="menu-block-container">
        <div class="menu-block menu-block-left">
          <slot name="left"></slot>
        </div>
        <div class="menu-block menu-block-center">
          <slot name="center"></slot>
        </div>
        <div class="menu-block menu-block-right">
          <slot name="right"></slot>
        </div>
      </div>
      <div class="menu-search">
        <slot name="search"></slot>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "v-nav",
  data() {
    return {
      isOpen: false
    };
  },
  watch: {
    $route(to, from) {
      this.isOpen = false;
      document.documentElement.classList.remove("nav-drop-on");
    }
  },
  methods: {
    onResize(event) {
      //console.log('window has been resized', event);
      let width = document.body.clientWidth;
      let height = document.body.clientHeight;
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) document.documentElement.classList.add("nav-drop-on");
      else document.documentElement.classList.remove("nav-drop-on");
    }
  },

  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss">
@import "../../design/variables.scss";
.v-nav-container {
  width: 100%;
}
.v-nav {
  position: relative;
  background-color: map-deep-get($colors, "background", "primary");
  height: 70px;
  width: 100%;
  z-index: 600;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  font-size: 1rem;
  padding: 0 10px;
  height: 70px;
  .menu-nav {
    cursor: pointer;
    display: none;
    z-index: 503;
    padding: 10px;
    .v-icon {
      opacity: 0.65;
    }
    &:hover {
      .v-icon {
        opacity: 1;
      }
    }
  }
  .menu-search {
    z-index: 503;
    display: flex;
    align-self: stretch;
    margin-left: 1rem;
    > a {
      display: flex;
      align-items: center;
      padding: 0 2rem;
      margin-right: -10px;
      color: map-deep-get($colors, "foreground", "primary");
      border-left: 1px solid map-deep-get($colors, "ornament", "divider");
    }
  }
  &.menuIsOpen {
    .menu-search {
      display: none;
    }
  }

  .menu-block-container {
    pointer-events: none;
    z-index: 502;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
  }

  .menu-block {
    pointer-events: all;
    display: flex;
    align-self: stretch;
    align-items: center;
  }

  .menu-block-left & {
    left: 0;
  }
  .menu-block-right & {
    right: 0;
  }
  .menu-block-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    img {
      height: 100%;
    }
  }
  .v-nav-item {
    .v-nav-item-title {
      a {
        display: block;
      }
    }
  }

  &::after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-color: map-deep-get($colors, "ornament", "divider");
  }
}
@media screen and (max-width: $grid-tablet-breakpoint) {
  .v-nav-container {
    position: sticky;
    top: -70px;
    z-index: 700;
  }
  .v-nav {
    position: relative;
    background-color: map-deep-get($colors, "background", "primary");
    height: 70px;
    width: 100%;
    z-index: 700;
    .menu-nav {
      display: block;
    }
    .menu-block {
      flex-direction: column;
    }
    .menu-block-logo {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100%;
      position: absolute;
      height: 100%;
      left: 0px;
      right: 0px;
      z-index: 50;
    }
    .menu-block-container {
      height: calc(100vh - 70px);
      z-index: 502;
      background-color: #fff;
      width: 100%;
      position: absolute;
      top: 70px;
      left: 0px;
      right: 0px;
      display: none;
      flex-direction: column;
      align-items: stretch;
      justify-content: stretch;
      align-content: start;
      overflow-x: hidden;
      overflow-y: auto;
    }
    &.menuIsOpen .menu-block-container {
      display: flex;
      justify-content: flex-start;
    }
    .v-nav-item {
      &.isOpen .v-dropdown-content {
        margin-left: 0%;
      }
    }
    .v-dropdown-content {
      transform-origin: top center;
      transition: margin 0.25s ease-in-out;
      position: absolute;
      left: 0;
      right: 0;
      margin-left: 100%;

      ul {
        columns: unset !important;
      }
    }
  }
}
</style>
